import { createFileRoute, Outlet } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach/questionnaires")({
  component: RouteComponent,
  ssr: true,
  async loader() {
    return loaderHandler(({ i18n }) => {
      return {
        data: null,
        breadcrumb: {
          href: "/questionnaires",
          label: i18n.t("formsPage.title"),
        },
      };
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
